import { BULK_ACTION_NAME, type BulkActionName } from './bulkActiontypes'

export type ApplicantsBulkAction = {
  id: BulkActionName
  label: string
}

export const applicantsBulkActions: ApplicantsBulkAction[] = [
  { id: BULK_ACTION_NAME.SMS, label: 'Send SMS' },
  { id: BULK_ACTION_NAME.Email, label: 'Send Email' },
  { id: BULK_ACTION_NAME.Call, label: 'Register Call' },
  { id: BULK_ACTION_NAME.Stage, label: 'Update Stage' },
  { id: BULK_ACTION_NAME.Sign, label: 'Sign Documents' },
  { id: BULK_ACTION_NAME.BackgroundCheck, label: 'Run Background Check' },
  { id: BULK_ACTION_NAME.AssignTraining, label: 'Assign Training' },
  {
    id: BULK_ACTION_NAME.RecruiterAssignment,
    label: 'Reassign Lead Recruiter',
  },
  {
    id: BULK_ACTION_NAME.MemberAssignment,
    label: 'Reassign Member Recruiters',
  },
]
